// extracted by mini-css-extract-plugin
export default {"heroVideo":"HeroVideo_heroVideo__ktPmR","video":"HeroVideo_video__L1weJ"};